import { render, staticRenderFns } from "./CoursePage.vue?vue&type=template&id=d1cf97d6&scoped=true&"
import script from "./CoursePage.vue?vue&type=script&lang=js&"
export * from "./CoursePage.vue?vue&type=script&lang=js&"
import style0 from "./CoursePage.vue?vue&type=style&index=0&id=d1cf97d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cf97d6",
  null
  
)

export default component.exports